import React from 'react'
import { View, StyleSheet, TouchableOpacity } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Icon } from '@components'

interface WebSidebarToggleProps {
  isMobile?: boolean
  isCollapsed: boolean
  onToggle: () => void
}

export const WebSidebarToggle: React.FC<WebSidebarToggleProps> = ({
  isCollapsed,
  onToggle,
  isMobile
}) => {
  const theme = useTheme()
  const styles = getStyle(theme, isMobile || false)

  return (
    <View style={[styles.profileSection, isMobile && {borderBottomWidth: 0}, isCollapsed && { borderBottomColor: theme.colors.grey10 }]}>
      <TouchableOpacity
        testID="web-sidebar-toggle"
        style={styles.toggleButton}
        onPress={onToggle}
        activeOpacity={0.7}
      >
        <Icon 
          name={isCollapsed ? "menu" : "cross"} 
          size={20} 
          color={theme.colors.text}
        />
      </TouchableOpacity>
    </View>
  )
}

const getStyle = (theme: Theme, isMobile: boolean) => StyleSheet.create({
  profileSection: {
    borderBottomWidth: 1,
    borderBottomColor: 'transparent',
    paddingHorizontal: isMobile ? 0 : theme.spacing.md,
  },
  toggleButton: {
    padding: theme.spacing.sm,
    backgroundColor: 'transparent',
    //alignItems: 'center',
    justifyContent: 'center',
  },
})
